import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CompetingAdsModule } from '../../competing-ads.module';
import { BaseCompetingAdsComponent } from '../../abstract-components/base-competing-ads.component';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { EventService } from '~app/app/~shared/services/event.service';
import { filter, tap } from 'rxjs';
import { GlobalEvent } from '~core/models/shared.models';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'competing-ads-list-page',
  standalone: true,
  imports: [CompetingAdsModule],
  templateUrl: './competing-ads-list-page.component.html',
  styleUrl: './competing-ads-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingAdsListPageComponent extends BaseCompetingAdsComponent {
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  isLoading$ = this._resourceFacade.isLoading$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }
}
